import { render, staticRenderFns } from "./AnnotationsSquare.vue?vue&type=template&id=2eaa8b3a&scoped=true&"
import script from "./AnnotationsSquare.vue?vue&type=script&lang=js&"
export * from "./AnnotationsSquare.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationsSquare.vue?vue&type=style&index=0&id=2eaa8b3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaa8b3a",
  null
  
)

export default component.exports